import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchInsertCounsellorsList } from "./helpAndAssistantApi";
import swal from 'sweetalert';
export interface insertCounsellorsListState {
  insertCounsellorsList: any;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: insertCounsellorsListState = {
  insertCounsellorsList: [],
  status: "idle",
};

export const GetinsertCounsellorsList = createAsyncThunk(
  "insertCounsellorsList",
  async (data: any) => {
    const response = await fetchInsertCounsellorsList(data);
    return response;
  }
);

export const insertCounsellorsListSlice = createSlice({
  name: "insertCounsellorsList",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetinsertCounsellorsList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetinsertCounsellorsList.rejected, (state, action) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetinsertCounsellorsList.fulfilled, (state, action) => {
        state.status = "success";
        state.insertCounsellorsList = action.payload;
        swal("Record saved success!",  "success");
      });
  },
});

export const {} = insertCounsellorsListSlice.actions;

export const selectinsertCounsellorsList = (state: RootState) => {
  return state.InsertCounsellorsList.insertCounsellorsList;
};

export default insertCounsellorsListSlice.reducer;
